import logo from "@/assets/logo.jpg";
import logoWebp from "@/assets/logo.webp";
import Picture from "@/components/Picture";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-gradient-to-b from-cream-100 via-cream-50 to-cream-50"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-32 top-10 h-80 w-80 rounded-full bg-blush-100 opacity-60 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-sage-100 opacity-70 blur-3xl"
      />

      <div className="section relative grid items-center gap-14 py-20 sm:py-24 lg:grid-cols-12 lg:gap-10 lg:py-28">
        <div className="lg:col-span-7">
          <p className="eyebrow">Now welcoming new patients</p>
          <h1 className="mt-4 font-serif text-4xl leading-tight text-sage-800 sm:text-5xl lg:text-6xl">
            A calm, confident path
            <br />
            to your <span className="italic text-blush-500">best smile</span>.
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-sage-700/90 sm:text-lg">
            Welcome to Dr. Amy Orthodontics. We focus on the needs of each
            patient to provide a comfortable experience in a relaxing, welcoming
            environment — with two locations in Fairfield County to serve you
            better.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a href="#contact" className="btn-primary">
              Request an appointment
            </a>
            <a href="#services" className="btn-secondary">
              Explore services
            </a>
          </div>

          <dl className="mt-12 grid gap-6 border-t border-sage-100 pt-8 sm:grid-cols-3">
            <div>
              <dt className="text-xs font-medium uppercase tracking-wider text-sage-500">
                Fairfield Office
              </dt>
              <dd className="mt-1 font-serif text-lg text-sage-800">
                <a href="tel:2032552677" className="hover:text-blush-500">
                  203-255-2677
                </a>
              </dd>
            </div>
            <div>
              <dt className="text-xs font-medium uppercase tracking-wider text-sage-500">
                Orange Office
              </dt>
              <dd className="mt-1 font-serif text-lg text-sage-800">
                <a href="tel:2037990600" className="hover:text-blush-500">
                  203-799-0600
                </a>
              </dd>
            </div>
            <div>
              <dt className="text-xs font-medium uppercase tracking-wider text-sage-500">
                Hours
              </dt>
              <dd className="mt-1 font-serif text-lg text-sage-800">
                Mon – Thu, 8am – 5pm
              </dd>
            </div>
          </dl>
        </div>

        <div className="relative lg:col-span-5">
          <div className="relative mx-auto aspect-square max-w-md overflow-hidden rounded-[2rem] border border-cream-300/60 bg-cream-100 shadow-soft">
            {/* Placeholder image: warm, candid lifestyle photo of a smiling patient
                in a bright, modern orthodontic office. Replace with a real photo. */}
            <div className="absolute inset-0 flex items-center justify-center p-10">
              <Picture
                webp={logoWebp}
                src={logo}
                alt="Dr. Amy Orthodontics logo"
                className="h-full w-full object-contain"
              />
            </div>
          </div>
          <div className="absolute -bottom-6 -left-6 hidden max-w-[15rem] rounded-2xl bg-sage-700 p-5 text-cream-50 shadow-soft sm:block">
            <p className="font-script text-2xl text-blush-200">Hi, I'm Dr. Amy.</p>
            <p className="mt-1 text-sm text-cream-100/90">
              Personalized, comfortable orthodontic care for every smile.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
